/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    onClickHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const cartDrawer = this.closest('cart-drawer');

      // CART DRAWER: fully handle remove here and do not let anything else redirect
      if (cartDrawer) {
        const lineItem =
          this.closest('.product-cart-item') ||
          this.closest('[data-key]') ||
          this.closest('[id^="CartDrawerItem-"]');

        if (!lineItem) return false;

        const updates = {};

        // main item key
        const mainKey =
          lineItem.dataset.key ||
          lineItem.closest('[data-key]')?.dataset.key;

        if (mainKey) {
          updates[mainKey] = 0;
        }

        // if this is the qualifying subscription parent, also remove gift
        const isGiftParent =
          lineItem.dataset.assignGiftProduct != null ||
          lineItem.querySelector?.('[data-assign-gift-product="true"]');

        if (isGiftParent) {
          const giftLineItem = cartDrawer.querySelector('.restrictProduct');
          const giftKey =
            giftLineItem?.dataset.key ||
            giftLineItem?.closest('[data-key]')?.dataset.key;

          if (giftKey) {
            updates[giftKey] = 0;
          }
        }

        if (!Object.keys(updates).length) return false;

        lineItem.classList.add('thb-loading');

        fetch(`${theme.routes.cart_update_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`
          },
          body: JSON.stringify({
            updates,
            sections: cartDrawer.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          })
        })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);

            cartDrawer.getSectionsToRender().forEach((section) => {
              const parent = document.getElementById(section.id);
              if (!parent) return;

              const elementToReplace = parent.querySelector(section.selector) || parent;

              if (parsedState.sections && parsedState.sections[section.section]) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              }
            });

            cartDrawer.notesToggle?.();

            dispatchCustomEvent('line-item:change:end', {
              quantity: 0,
              cart: parsedState
            });
          })
          .catch((error) => {
            console.error('Cart drawer remove failed:', error);
          });

        return false;
      }

      // CART PAGE
      const index = this.dataset.index;
      document.dispatchEvent(
        new CustomEvent('cart:remove', {
          detail: { index }
        })
      );

      return false;
    }
  }

  customElements.define('cart-remove', CartRemove);
}